function e(e,t){const a=document.createElement("a");a.href=URL.createObjectURL(e),a.download=t,a.target="_blank",a.click()}export{e as default};
